module.exports = __webpack_public_path__ + "media/images/flags/64/Qatar-9427fa70994511754e8a8af628264385.png";